import { useMemo } from 'react';
import { RefPermissionEnum } from '@trinity/management-app-client/enums';
import { useAppSelector } from '@/store';

export const useBrandInsightsCapabilities = () => {
  const permissions = useAppSelector((state) => state.user?.permissions);

  return useMemo(() => {
    if (!permissions) {
      return {
        canApplyFilters: false,
        canViewTraces: false,
        canViewExternalLinks: false,
        canAddToDashboard: true,
      };
    }

    return {
      canApplyFilters: permissions.includes(RefPermissionEnum.ApplyFilters),
      canViewTraces: permissions.includes(RefPermissionEnum.ViewChatTraces),
      canViewExternalLinks: true,
      canAddToDashboard: true,
    };
  }, [permissions]);
};
